import React from "react";
import styled from "styled-components";
import Footer from "./Footer";
import Header from "./Header";

const BodyContainer = styled.section`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
`;

const MainContent = styled.main`
  flex: 1 0 auto;
`;

function PageShell({ children }) {
  return (
    <BodyContainer>
      <Header />
      <MainContent>{children}</MainContent>
      <Footer />
    </BodyContainer>
  );
}

export default PageShell;
